import { Tracker } from "./Tracker";
var PromiseTracker = /** @class */ (function () {
    function PromiseTracker() {
    }
    PromiseTracker.prototype.TrackLoadingPromiseDetailed = function (promise) {
        var trackingObj = new Tracker();
        this.HandleLoadingPromise(promise, {
            fulfilled: function () { trackingObj.fulfilled = true; },
            rejected: function () { trackingObj.rejected = true; },
            finally: function () { trackingObj.pending = false; }
        });
        return {
            tracker: trackingObj,
            promise: promise
        };
    };
    PromiseTracker.prototype.TrackLoadingPromise = function (promise, loadingObj) {
        this.HandleLoadingPromise(promise, {
            start: function () { loadingObj.isLoading = true; },
            finally: function () { loadingObj.isLoading = false; }
        });
    };
    PromiseTracker.prototype.HandleLoadingPromise = function (promise, promiseEvents) {
        var _a;
        if (promise instanceof Function)
            promise = promise();
        (_a = promiseEvents.start) === null || _a === void 0 ? void 0 : _a.call(promiseEvents, promise);
        return promise.then(function (result) {
            var _a, _b;
            (_a = promiseEvents.fulfilled) === null || _a === void 0 ? void 0 : _a.call(promiseEvents, result);
            (_b = promiseEvents.finally) === null || _b === void 0 ? void 0 : _b.call(promiseEvents, promise);
            return result;
        }, function (err) {
            var _a, _b;
            (_a = promiseEvents.rejected) === null || _a === void 0 ? void 0 : _a.call(promiseEvents, err);
            (_b = promiseEvents.finally) === null || _b === void 0 ? void 0 : _b.call(promiseEvents, promise);
            throw err;
        });
    };
    return PromiseTracker;
}());
export { PromiseTracker };
export var promiseTracker = new PromiseTracker();
